// extracted by mini-css-extract-plugin
module.exports = {"container":"PrimaryInformation_container__315Lh","divider":"PrimaryInformation_divider__15wPT"};